const config = {
  pagarmeKey: process.env.REACT_APP_PAGARME_KEY,
  apiUrl: process.env.REACT_APP_API_URL,
  storageEndpoint: process.env.REACT_APP_STORAGE_ENDPOINT,
  chatURL: process.env.REACT_APP_CHAT_URL,
  baseURL: process.env.REACT_APP_BASE_URL,
  env: process.env.REACT_APP_ENV,
  buildNumber: process.env.REACT_APP_BUILD_NUMBER || 0,
  zendeskURL: process.env.REACT_APP_ZENDESK_URL,
  bucketName: process.env.REACT_APP_ADMIN_STORAGE_BUCKET_NAME,
  bucketRegion: process.env.REACT_APP_ADMIN_STORAGE_BUCKET_REGION,
  bucketPoolId: process.env.REACT_APP_ADMIN_STORAGE_POOL_ID,
  sambaPlatformUploadKey: process.env.REACT_APP_SAMBATECH_PLATFORM_UPLOAD_KEY,
  sambaIosUplaodKey: process.env.REACT_APP_SAMBATECH_IOS_UPLOAD_KEY,
  vimeoClientID: process.env.REACT_APP_VIMEO_CLIENT_ID,
  vimeoAccessToken: process.env.REACT_APP_VIMEO_ACCESS_TOKEN,
  vimeoClientSecret: process.env.REACT_APP_VIMEO_CLIENT_SECRET,
  sambaIosPid: process.env.REACT_APP_SAMBATECH_IOS_PID,
  sambaPlatformPid: process.env.REACT_APP_SAMBATECH_PLATFORM_PID,
  sambaPlatformAccessToken: process.env.REACT_APP_SAMBATECH_PLATFORM_ACCESS_TOKEN,
  sambaIosAccessToken: process.env.REACT_APP_SAMBATECH_IOS_ACCESS_TOKEN,
  sambaUrlApi: process.env.REACT_APP_SAMBATECH_API_URL,
  vimeoUrlApi: process.env.REACT_APP_VIMEO_API_URL
};

export default config;
